module.exports = __webpack_public_path__ + "static/media/logo.d48c14ad.jpg";